
<!-- links müssen immer das a-Tag benutzen, damit das Ziel in einem anderen Tab geöffnet werden kann -->
<!-- disabling needs some trickery because links do not support the disabled attribute -->

<!-- active routerLink -->
@if (route && !disabled) {
  <a
    [routerLink]="route" [queryParams]="queryParams" [state]="state"
    [hisImage]="img" [title]="title" [ariaLabel]="title" [class]="activeClass"
  	(click)="onBeforeNavigate()" 
  	[hisSearchResult]="genericSearchResult" 
  	[selectedIndex]="genericSearchResultIndex">{{text ?? ''}}</a>
}

<!-- active href -->
@if (href && !disabled) {
  <a
    [href]="href" [class]="activeClass"
    [hisImage]="img" [title]="title" [ariaLabel]="title"
    (click)="onBeforeNavigate()">{{text ?? ''}}</a>
}

<!-- disabled -->
@if (disabled) {
  <span class="hisLinkDisabled">
    @if (img) {
      <img [hisImage]="img + '_i'" class="inlineicon imggrey" [title]="title" [ariaLabel]="title + ' ' + ('cs.sys.common.linkInactive' | hisUi)">
    }
    <span class="hisLinkDisabledText">{{text ?? ''}}</span>
  </span>
}
